import { useState, useEffect } from "react";
import { Table, Button } from "reactstrap";
import { Avatar, Tooltip, Pagination } from "antd";
import { FiEdit2, FiEye, FiTrash2 } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { findObjById } from "../../utility";
import NotFoundDataUI from "../cards/NotFoundDataUI";
import DeleteModal from "../modals/DeleteModal";

const SubCategoryTable = ({
  toggle,
  handleDelete,
  data,
  setSelectedSubCategory,
  onClearSearch,
}) => {
  const history = useHistory();
  const { all_categories } = useSelector((state) => state.redux);
  const { user } = useSelector((state) => state.auth);

  const [currentPage, setCurrentPage] = useState(1);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [pageSize, setPageSize] = useState(50);

  useEffect(() => {
    setCurrentPage(1);
  }, [data?.length]);

  const paginatedData = data?.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return (
    <div>
      <Table
        responsive
        hover
        bordered
        className="mb-0"
        style={{
          fontSize: "13px",
          overflow: "hidden",
          border: "1px solid #e2e8f0"
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#00509d", color: "white" }}>
            <th className="text-center" style={{ borderBottom: "none" }}>ID</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Image</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Sub Category Title</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Parent Category</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Identifiers</th>
            <th className="text-center" style={{ borderBottom: "none" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData && paginatedData.length > 0 ? paginatedData.map((subCategory, index) => {
            const parentCategory = findObjById(all_categories, subCategory?.categoryId);
            return (
              <tr
                key={index}
                className="align-middle"
                style={{
                  backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                  borderBottom: "1px solid #f1f5f9"
                }}
              >
                <td className="text-center text-muted">
                  {subCategory?.id || (currentPage - 1) * pageSize + index + 1}
                </td>
                <td className="text-center">
                  <Avatar
                    src={
                      subCategory?.subCategoryImage ??
                      subCategory?.subCategoryImageURL
                    }
                    size={32}
                    className="shadow-sm border"
                  />
                </td>
                <td className="text-center fw-bold">
                  {subCategory?.subCategoryName}
                </td>
                <td className="text-center">
                  <span className="user-badge bg-primary-soft">
                    {parentCategory?.categoryName || "N/A"}
                  </span>
                </td>
                <td className="text-center">
                  <div className="text-uppercase small text-muted">
                    {subCategory?.identifiers && subCategory.identifiers.length > 0
                      ? subCategory.identifiers.join(", ")
                      : "techmicro"}
                  </div>
                </td>
                <td className="text-center">
                  <div className="d-flex align-items-center justify-content-center gap-2">
                    <Tooltip title="Edit Sub-Category">
                      <Button
                        color="link"
                        className="p-1 border-0"
                        onClick={() => {
                          setSelectedSubCategory(subCategory);
                          toggle();
                        }}
                      >
                        <FiEdit2 className="text-primary" size={14} />
                      </Button>
                    </Tooltip>
                    <Tooltip title="View Details">
                      <Button
                        color="link"
                        className="p-1 border-0"
                        onClick={() => {
                          history.push({
                            pathname: `/admin/subCategory-details/${subCategory?._id}`,
                            state: subCategory,
                          });
                        }}
                      >
                        <FiEye className="text-info" size={18} />
                      </Button>
                    </Tooltip>
                    {(user?.role === "Admin" || user?.role === "Super-admin") && (
                      <Tooltip title="Delete Sub-Category">
                        <Button
                          color="link"
                          className="p-1 border-0"
                          onClick={() => {
                            setItemToDelete(subCategory?._id);
                            setDeleteModalOpen(true);
                          }}
                        >
                          <FiTrash2 className="text-danger" size={16} />
                        </Button>
                      </Tooltip>
                    )}
                  </div>
                </td>
              </tr>
            );
          }) : (
            <tr>
              <td colSpan="6" className="text-center py-4">
                <NotFoundDataUI 
                  message="No sub-categories found!" 
                  onClearSearch={onClearSearch}
                />
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      {data && data.length > 0 && (
        <div className="d-flex justify-content-end p-3 bg-white border-top border-start border-end border-bottom">
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={data.length}
            onChange={(page) => setCurrentPage(page)}
            showSizeChanger={true}
            onShowSizeChange={(current, size) => {
              setPageSize(size);
              setCurrentPage(1);
            }}
            pageSizeOptions={['10', '25', '50', '100']}
          />
        </div>
      )}
      <DeleteModal 
        modal={deleteModalOpen} 
        toggle={() => setDeleteModalOpen(false)} 
        handleDelete={() => {
          handleDelete(itemToDelete);
          setDeleteModalOpen(false);
        }} 
      />
    </div>
  );
};


export default SubCategoryTable;
